import React, { Component } from "react";
import "../../App.css";
import AppNavbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Team2023 from "./Team2023";
import Team2022 from "./Team2022";
import Team2019 from "./Team2019";
import $ from "jquery";

export default class PreviousTeams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teamCollection: <Team2023 />,
    };
    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onClick(e) {
    const year = e.target.id;
    if (year === "2023") {
      this.setState({
        teamCollection: <Team2023 />,
      });
    } else if (year === "2022") {
      this.setState({
        teamCollection: <Team2022 />,
      });
    } else if (year === "2019") {
      this.setState({
        teamCollection: <Team2019 />,
      });
    }
    $(".team-tab").removeClass().addClass("nav-link non-active team-tab");
    $("#" + year)
      .removeClass("non-active")
      .addClass("active");
  }

  render() {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh' 
      }}>
        <AppNavbar />
        <div className="parallax team">
          <div className="big-font bottom-quote" id="team">
            Team Alumni
          </div>
        </div>
        <div className="col-lg-10 body-content" style={{ flex: 1 }}>
          <div className="row mt-5 mb-5 mr-2 ml-2">
            <div className="col-lg card">
              <div className="card-body">
                <p>
                  Explore our team's rich history and meet the talented individuals who have contributed to the University of Toronto Seismic Design Team over the years. Each year brings new challenges, innovations, and achievements as our team continues to grow and excel in the EERI Undergraduate Seismic Design Competition.
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="card mb-5">
              <div className="card-header">
                <ul className="nav nav-tabs card-header-tabs">
                  <li className="nav-item">
                    <button
                      id="2023"
                      className="nav-link active team-tab"
                      onClick={this.onClick}
                    >
                      2023
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      id="2022"
                      className="nav-link non-active team-tab"
                      onClick={this.onClick}
                    >
                      2022
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      id="2019"
                      className="nav-link non-active team-tab"
                      onClick={this.onClick}
                    >
                      2019
                    </button>
                  </li>
                </ul>
              </div>
              <div className="card-body">{this.state.teamCollection}</div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
